module.exports = __webpack_public_path__ + "static/media/2.65c03d56.png";